/// <reference types="pixi.js"/>

declare module PIXI {
	export interface Container {
		containerRenderWebGL(renderer: WebGLRenderer): void;
	}
}

module PIXI.display {
	import WebGLRenderer = PIXI.WebGLRenderer;
	import CanvasRenderer = PIXI.CanvasRenderer;
	import Container = PIXI.Container;

	(Object as any).assign(Container.prototype, {
		/**
		 * TODO: pass displayOrderContext or something like that. renderer is not needed
		 * @param renderer
		 */
		updateDisplay(layer: Layer) {
			const view = this.view;
			if (view) {
				if (view._activeParentLayer && view._activeParentLayer != layer)
					return;

				if (!layer || !this.visible) {
					view.layerOrder = 0;
				} else {
					view.layerOrder = layer.incDisplayOrder();
				}
			}
			if (!this.visible) {
				return;
			}
			if (this.layerableChildren) {
				const children = this.children;
				for (let i = 0; i < children.length; i++) {
					children[i].updateDisplay(layer);
				}
			}
		},

		renderWebGL: function (renderer: WebGLRenderer): void {
			if (this.view && this.view._activeParentLayer && this.view._activeParentLayer != renderer._activeLayer) {
				return;
			}

			// if the object is not visible or the alpha is 0 then no need to render this element
			if (!this.visible || this.worldAlpha <= 0 || !this.renderable) {
				return;
			}

			if (renderer.depthMode === DEPTH_MODE.FRONT_TO_BACK) {
				//the simplest solution
				if (this._mask || this._filters) {
					return
				}

				const children = this.children;
				for (let i = children.length - 1; i >= 0; i--) {
					children[i].renderWebGL(renderer);
				}
				this._renderWebGL(renderer);
			} else {
				this.pixiContainerRenderWebGL(renderer);
			}
		},
		pixiContainerRenderWebGL: PIXI.Container.prototype.renderWebGL
	});
}